/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ServiceAccountsControllerListKeysQueryResponse, ServiceAccountsControllerListKeysPathParams, ServiceAccountsControllerListKeysQueryParams, ServiceAccountsControllerListKeys401, ServiceAccountsControllerListKeys403 } from "../../models/serviceAccountsController/ServiceAccountsControllerListKeys";

function getServiceAccountsControllerListKeysUrl(orgId: ServiceAccountsControllerListKeysPathParams["orgId"]) {
  const res = { method: 'GET', url: `/api/v1/organizations/${orgId}/api-keys` as const }  
  return res
}

/**
 * @summary List active service account keys
 * {@link /api/v1/organizations/:orgId/api-keys}
 */
export async function serviceAccountsControllerListKeys(orgId: ServiceAccountsControllerListKeysPathParams["orgId"], params?: ServiceAccountsControllerListKeysQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ServiceAccountsControllerListKeysQueryResponse, ResponseErrorConfig<ServiceAccountsControllerListKeys401 | ServiceAccountsControllerListKeys403>, unknown>({ method : "GET", url : getServiceAccountsControllerListKeysUrl(orgId).url.toString(), params, ... requestConfig })  
  return res.data
}